module.exports = __webpack_public_path__ + "media/flags/mm-2ddb3c8b.svg";